export const name = "COSH";
export const summary = `Computes the hyperbolic cosine of \`X\`.`;
export const reference = `
## COSH

Computes the hyperbolic cosine of \`X\`.

\`\`\`
COSH(X)
\`\`\`

### Description

Computes the hyperbolic cosine of X where X is specified in radians. Generates an error if overflow occurs.

| X | COSH(X) |
| --- | --- |
| \`+inf\` | \`+inf\` |
| \`-inf\` | \`+inf\` |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
